<template>
  <v-app>
    <go-top></go-top>
    

<div class="_hello">
      <v-container fixed fluid grid-list-md class="mrgn">
          <v-layout row wrap>
                <v-flex md1 sm12 xs12></v-flex>
                <v-flex md8 sm12 xs12>
                          
                        <v-form ref="form1" v-model="valid" lazy-validation>
                              <v-layout row wrap>
              
                                 <v-flex md3 sm12 xs12>

                                    <v-autocomplete
                                     class="ss elevation-3"
                                     style="background-color:white"
                                     append-icon="location_city"
                                     outline
                                     v-model="selectedCity"
                                     :items="cities"
                                     color="primary"
                                     label="Search by Cities"
                                     item-text="cityName"
                                     item-value="id"
                                     clearable
                                     :rules="emptyRule" 
                                     required
                                   ></v-autocomplete>
                                </v-flex>
                 <v-flex md2 sm12 xs12>
                    <v-dialog ref="dialog" v-model="checkInModel" persistent lazy full-width width="310px">
                           <v-text-field
                             class="ss1 elevation-3"
                             style="background-color:white"
                             outline
                             append-icon="event"
                             slot="activator"
                             v-model="form1.checkIn"
                             label="Check-In"
                             readonly
                             :rules="emptyRule" 
                             required
                           ></v-text-field>
                              <v-date-picker v-model="form1.checkIn" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="checkInModel = false">Ok</v-btn>
                              </v-date-picker>
                    </v-dialog>
                  </v-flex>
                 <v-flex md2 sm12 xs12>
                    <v-dialog ref="dialog" v-model="checkOutModel" persistent lazy full-width width="310px">
                         <v-text-field
                           class="ss1 elevation-3"
                           style="background-color:white"
                           outline
                           append-icon="event"
                           slot="activator"
                           v-model="form1.checkOut"
                           label="Check-Out"
                           readonly
                           :rules="emptyRule" 
                           required
                         ></v-text-field>
                         <v-date-picker v-model="form1.checkOut" scrollable>
                           <v-spacer></v-spacer>
                           <v-btn flat color="primary" @click="checkOutModel = false">Ok</v-btn>
                         </v-date-picker>
                    </v-dialog>
                 </v-flex>
                 
                 <v-flex md1>
                  <v-text-field
                    class="ss1 elevation-3"
                    style="background-color:white"
                    outline
                    v-model="selectedRoom"
                    label="Rooms"
                    @click.stop="dialog1 = true"
                    :rules="emptyRule" 
                    required
                  ></v-text-field>
                 </v-flex>
                  <v-flex md2>
                    <v-text-field
                     class="ss1 elevation-3"
                     style="background-color:white"
                    outline
                    v-model="selectedAdult"
                    label="Adult(s)"
                    @click.stop="dialog1 = true"
                    :rules="emptyRule" 
                    required
                  ></v-text-field>
                  </v-flex>

                  <v-flex md2>
                    <v-text-field
                     class="ss1 elevation-3"
                     style="background-color:white"
                    outline
                    v-model="selectedChildren"
                    label="Children"
                    @click.stop="dialog1 = true"
                    :rules="emptyRule" 
                    required
                  ></v-text-field>
                  </v-flex>

                 <v-dialog
                     v-model="dialog1"
                     max-width="500"
                 >
    
                   <v-card style="background-color: #ffffff" class="redius">
                       <div style="color:red">

                              <v-card flat color="transparent">
                                  <v-layout row wrap>
                                <v-flex xs12 md4 sm4 style="padding-right: 5px">
                                  <v-autocomplete
                                     v-model="selectedRoom"
                                     :items="rooms"
                                     color="primary"
                                     label="Rooms"
                                     item-text="rooms"
                                     item-value="rooms"
                                     clearable
                                     :rules="emptyRule" 
                                     required
                                   ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 md4 sm4 style="padding-right: 5px">
                                  <v-autocomplete
                                     v-model="selectedAdult"
                                     :items="adults"
                                     color="primary"
                                     label="Adult(s)"
                                     item-text="adults"
                                     item-value="adults"
                                     clearable
                                     :rules="emptyRule" 
                                     required
                                   ></v-autocomplete>
                                </v-flex>

                                <v-flex xs12 md4 sm4>
                                  <v-autocomplete
                                     v-model="selectedChildren"
                                     :items="children"
                                     color="primary"
                                     label="Children"
                                     item-text="children"
                                     item-value="children"
                                     clearable
                                     :rules="emptyRule" 
                                     required
                                   ></v-autocomplete>
                                </v-flex>

                                  <v-flex xs12 md8 sm8>
                                   
                                  </v-flex>
                                  <v-flex xs12 md4 sm4>
                                     <v-btn color="#ff336d" class="white--text" @click="dialog1 = false" round depressed>
                                     Done
                                   </v-btn>
                                  </v-flex>
                                 
                              </v-layout>
                                  
                                 </v-card>

                              
                      </div>
                          <br/>
                    </v-card>
                     </v-dialog>
                        </v-layout>
                   </v-form>
    
            </v-flex>
              <v-flex md2 sm12 xs12>
                <v-btn color="white black--text" class="elevation-7" :loading="srch" round large block depressed @click="searchHotel()">SEARCH</v-btn>
              </v-flex>

</v-layout>
</v-container>
</div>

<!------------------------------------------------------------------------------------------------------------------>
<!------------------------------------------------------------------------------------------------------------------>
<!------------------------------------------------------------------------------------------------------------------>


<div id="hello">
  <vue-easy-lightbox
    :visible="visible"
    :imgs="imgs"
    @hide="handleHide"
  ></vue-easy-lightbox>
  <v-layout row wrap>
    <v-flex xs12 class="man">
      <b-navbar toggleable="md" type="light" style="margin-top:30px">
     <b-navbar-brand href="#" style="padding-left:25px;padding-right:25px;color:white;background-color:#ff336d;">SELECT FILTERS</b-navbar-brand>

     <b-navbar-toggle target="nav-collapse1"></b-navbar-toggle>

     <b-collapse id="nav-collapse1" is-nav>
     

      
      <b-navbar-nav class="ml-auto">
        
           <v-container class="form-container elevation-1 swo" style="border-radius:0%">
           <v-layout row wrap>
            
             <br/>
              <v-flex xs12 md12 sm12 style="padding-left:50px">
                <v-layout row wrap>
                   <v-flex xs12 md8 sm8>
                     <p class="black--text" style="text-align:left;margin-bottom: -10px;margin-top:20px;text-transform:uppercase">Price Per Night</p>
                       <v-range-slider
                          v-model="range"
                          :max="max"
                          :min="min"
                          hide-details
                          color="#7b1fa2"
                          class="align-center"
                        ></v-range-slider>
                   </v-flex>
                   <v-flex xs12 md3 sm3>
                     <v-text-field
                        label="Min INR"
                        v-model="range[0]"
                      ></v-text-field>
                   </v-flex>
                   <v-flex xs12 md4 sm4>
                       
                   </v-flex>
                   <v-flex xs12 md3 sm3>
                      <v-text-field
                        label="Max INR"
                        v-model="range[1]"
                      ></v-text-field>
                   </v-flex>
                </v-layout>
              </v-flex>
              
              <v-flex xs12 md12 sm12 style="padding-left:50px">
                 <v-layout row wrap>
                    <v-flex xs12 md10 sm10>
                      <p class="black--text" style="text-align:left;margin-top:20px;text-transform:uppercase">Star Category</p>
                    </v-flex>
                    <v-flex xs12 md10 sm10>
                      <b-form-checkbox size="sm" style="margin-bottom:10px;color:black;font-size:15px" v-model="checked" name="check-button" switch>
                        &nbsp;5 Star
                      </b-form-checkbox>
                      <b-form-checkbox size="sm" style="margin-bottom:10px;color:black;font-size:15px;font-weight:lighter !important" v-model="checked" name="check-button" switch>
                        &nbsp;4 Star
                      </b-form-checkbox>
                      <b-form-checkbox size="sm" style="margin-bottom:10px;color:black;font-size:15px" v-model="checked" name="check-button" switch>
                        &nbsp;3 Star
                      </b-form-checkbox>
                      <b-form-checkbox size="sm" style="margin-bottom:10px;color:black;font-size:15px" v-model="checked" name="check-button" switch>
                        &nbsp;2 Star
                      </b-form-checkbox>
                      <b-form-checkbox size="sm" style="margin-bottom:10px;color:black;font-size:15px" v-model="checked" name="check-button" switch>
                        &nbsp;1 Star
                      </b-form-checkbox>
                      <b-form-checkbox size="sm" style="color:black;font-size:15px" v-model="checked" name="check-button" switch>
                        &nbsp;Unrated
                      </b-form-checkbox>
                    </v-flex>
                 </v-layout>
              </v-flex>



          
           </v-layout>
        </v-container>
        
       

       
      </b-navbar-nav>
     </b-collapse>
      </b-navbar>
    </v-flex>

    <v-flex md2 sm2 xs12 class="res">
      
        <v-container class="form-container elevation-1 swo" style="border-radius:0%">
           <v-layout row wrap>
             <v-flex xs12 md12 sm12 style="padding-left:30px;background-color:#ff336d;margin-top:40px;">
               <h5 style="text-align:left;color:#ffffff;text-transform:uppercase;padding:5px;padding-top: 10px !important;">Select Filters</h5>
             </v-flex>
             <br/>
              <v-flex xs12 md12 sm12 style="padding-left:50px">
                <v-layout row wrap>
                   <v-flex xs12 md10 sm10>
                     <p class="black--text" style="text-align:left;margin-bottom: -10px;margin-top:20px;text-transform:uppercase">Price Per Night</p>
                       <v-range-slider
                          v-model="range"
                          :max="max"
                          :min="min"
                          hide-details
                          color="#7b1fa2"
                          class="align-center"
                        ></v-range-slider>
                   </v-flex>
                   <v-flex xs12 md3 sm3>
                     <v-text-field
                        label="Min INR"
                        v-model="range[0]"
                      ></v-text-field>
                   </v-flex>
                   <v-flex xs12 md4 sm4>
                       
                   </v-flex>
                   <v-flex xs12 md3 sm3>
                      <v-text-field
                        label="Max INR"
                        v-model="range[1]"
                      ></v-text-field>
                   </v-flex>
                </v-layout>
              </v-flex>
              
              <v-flex xs12 md12 sm12 style="padding-left:50px">
                 <v-layout row wrap>
                    <v-flex xs12 md10 sm10>
                      <p class="black--text" style="text-align:left;margin-top:20px;text-transform:uppercase">Star Category</p>
                    </v-flex>
                    <v-flex xs12 md10 sm10>
                      <b-form-checkbox size="sm" style="margin-bottom:10px;color:black;font-size:15px" v-model="checked" name="check-button" switch>
                        &nbsp;5 Star
                      </b-form-checkbox>
                      <b-form-checkbox size="sm" style="margin-bottom:10px;color:black;font-size:15px;font-weight:lighter !important" v-model="checked" name="check-button" switch>
                        &nbsp;4 Star
                      </b-form-checkbox>
                      <b-form-checkbox size="sm" style="margin-bottom:10px;color:black;font-size:15px" v-model="checked" name="check-button" switch>
                        &nbsp;3 Star
                      </b-form-checkbox>
                      <b-form-checkbox size="sm" style="margin-bottom:10px;color:black;font-size:15px" v-model="checked" name="check-button" switch>
                        &nbsp;2 Star
                      </b-form-checkbox>
                      <b-form-checkbox size="sm" style="margin-bottom:10px;color:black;font-size:15px" v-model="checked" name="check-button" switch>
                        &nbsp;1 Star
                      </b-form-checkbox>
                      <b-form-checkbox size="sm" style="color:black;font-size:15px" v-model="checked" name="check-button" switch>
                        &nbsp;Unrated
                      </b-form-checkbox>
                    </v-flex>
                 </v-layout>
              </v-flex>



          
           </v-layout>
        </v-container>
        
         
     
      
    </v-flex>
    <v-flex md10 sm12 xs12 class="res">
       <v-data-table style="" hide-actions :items="hotels" >
        <template v-slot:items="props">
          <td class="hvr" style="border-bottom:none !important;">
              <v-container class="form-container elevation-5">
              <v-layout row wrap>
                  <v-flex xs12 md4 sm4 class="logopoint">
                      <img style="padding-left:15px" :src=props.item.src1 height="280px" @click="showMultiple(props.item)" width="400px">
                  </v-flex>
                  <v-flex xs12 md2 sm2 class="logopoint" style="padding-left:15px">
                      <img :src=props.item.src2 height="70px" @click="showMultiple(props.item)" width="100px">
                      <img :src=props.item.src3 height="70px" @click="showMultiple(props.item)" style="padding-top:5px" width="100px">
                      <img :src=props.item.src4 height="70px" @click="showMultiple(props.item)" style="padding-top:5px" width="100px">
                      <img :src=props.item.src5 height="70px" @click="showMultiple(props.item)" style="padding-top:5px" width="100px">
                  </v-flex>
                  <v-flex xs12 md4 sm4>
                    <h2 class="hotel_name1">{{props.item.hotelName}}</h2>

                    <!-- FOR RATING -->
                    <!-- ================================================================================== -->

                      <div v-if="props.item.rating === 0">
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 1">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 1.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 2">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 2.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 3">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 3.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 4">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 4.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      

                      <!-- ================================================================================== -->
                      
                      <br/>
                      <h6>{{props.item.billingAddress}}</h6>
                      <br/>
                     <h5>+91 6290398678</h5>
                     <br/>
                     <div class="aminity">
                      <p class="aminities" style="font-size:12px" v-if="props.item.parkingPlace === true"><v-icon size="20px" color="grey">local_taxi</v-icon>&nbsp;Parking Place</p>
                      <p class="aminities" style="font-size:12px" v-if="props.item.telephone === true"><v-icon size="20px" color="grey">phone</v-icon>&nbsp;Telephone</p>
                      <p class="aminities" style="font-size:12px" v-if="props.item.fullTimeService === true"><v-icon size="20px" color="grey">room_service</v-icon>&nbsp;Room Service</p>
                     </div>
                     <div class="aminity">
                      <p class="aminities white--text" style="font-size:12px" v-if="props.item.parkingPlace === false"><v-icon size="20px" color="white">local_taxi</v-icon>&nbsp;Parking Place</p>
                      <p class="aminities white--text" style="font-size:12px" v-if="props.item.telephone === false"><v-icon size="20px" color="white">phone</v-icon>&nbsp;Telephone</p>
                      <p class="aminities white--text" style="font-size:12px" v-if="props.item.fullTimeService === false"><v-icon size="20px" color="white">room_service</v-icon>&nbsp;Room Service</p>
                     </div>


                     <v-btn depressed class="white--text" color="#ff336d" @click="view(props.item)">
                       <v-icon color="white">visibility</v-icon>&nbsp;View Details</v-btn>
                       <v-btn depressed color="primary" @click="view(props.item)">
                      <v-icon color="white">book</v-icon>&nbsp;Book now</v-btn>
                  </v-flex>
                  <v-flex xs12 md2 sm2 style="padding-right:15px">
                    <v-container class="form-container rate">
                       <p v-if="props.item.breakFast === true" style="font-size:10px; text-align:center; margin-bottom: 5px;" class="white--text">INCLUDE IN THIS PRICE</p>
                       <p v-if="props.item.breakFast === true" class="lime--text" style="font-size:11px; text-align:center; margin-bottom: 15px;"><v-icon color="#c6ff00" size="14px">done</v-icon>&nbsp;Free Breakfast</p>

                       <!-- ========================================================================== -->
                       <p v-if="props.item.breakFast === false" style="font-size:10px; text-align:center; margin-bottom: 5px;" class="white--text lineThrough">INCLUDE IN THIS PRICE</p>
                       <p v-if="props.item.breakFast === false" class="lime--text lineThrough" style="font-size:11px; text-align:center; margin-bottom: 15px;">Free Breakfast</p>
                       <!-- ========================================================================== -->

                       <p style="text-align:center; margin-bottom:0px;">
                         <span class="yellowText font12">
                           <span>Save </span>
                           <span class="latoBold">INR {{props.item.save}} <v-btn class="ma-2 " style="pointer-events: none;border-radius:50%" fab color="yellow">
                            <h5 style="margin-top:5px">{{props.item.discount}}%</h5>
                           </v-btn></span>
                         </span>
                       </p>
                       <p class="lineThrough" style="text-align:center; color:#e0e0e0; font-size:15px; margin-bottom:0px;">INR {{props.item.regularPrice}}</p>
                       <p class="white--text" style="text-align:center; font-size:25px; margin-top:0px;margin-bottom:0px;">INR {{props.item.actualPrice}}</p>
                       <p style="text-align:center; margin-top:0px;margin-bottom:0px; color:#e0e0e0">Per night</p>
                       <p style="text-align:center; color:#e0e0e0">All Tax Included</p>
                    </v-container>
                  </v-flex>
              </v-layout>
              </v-container>
              <br>
          </td>
                  </template>
      </v-data-table>
    </v-flex>

     <v-flex md12 sm12 xs12 class="man">
       <v-data-table hide-actions :items="hotels" >
        <template v-slot:items="props">
          <td class="hvr" style="border-bottom:none !important;">
              <v-container class="elevation-5">
              <v-layout row wrap>
                <v-flex xs12 style="text-align:center">
                   <h2 class="hotel_name1">{{props.item.hotelName}}</h2>

                    <!-- FOR RATING -->
                    <!-- ================================================================================== -->

                      <div v-if="props.item.rating === 0">
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 1">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 1.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 2">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 2.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 3">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 3.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 4">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_border</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 4.5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star_half</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                      <div v-if="props.item.rating === 5">
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-icon color="#fdd835">star</v-icon>
                        <v-chip
                           color="#3486d7"
                           class="white--text"
                           style="border-radius:5%"
                           label
                           small
                         >
                           {{ props.item.rating }}/5
                        </v-chip>
                      </div>
                </v-flex>
                <v-flex xs12 class="logopoint" style="width:100%">
                  <img :src=props.item.src1 height="280px" @click="showMultiple(props.item)" width="100%">
                </v-flex>
                  <v-flex xs12 class="logopoint" style="width:100%">
                    <img :src=props.item.src2 height="70px" @click="showMultiple(props.item)" style="padding-top:5px" width="25%">
                      <img :src=props.item.src3 height="70px" @click="showMultiple(props.item)" style="padding-top:5px" width="25%">
                      <img :src=props.item.src4 height="70px" @click="showMultiple(props.item)" style="padding-top:5px" width="25%">
                      <img :src=props.item.src5 height="70px" @click="showMultiple(props.item)" style="padding-top:5px" width="25%">
                    
                  </v-flex>
                  
                      
                  
                  <v-flex xs12 md4 sm4>
                  

                      <!-- ================================================================================== -->
                      
                      <br/>
                      <h6>{{props.item.billingAddress}}</h6>
                      <br/>
                     <h5>+91 6290398678</h5>
                     <br/>
                     <!-- <v-layout>
                        <v-flex xs12 md12 sm12>
                           <p v-if="props.item.parkingPlace === true"><v-icon color="grey">local_taxi</v-icon>&nbsp;Parking Place</p>
                           <p v-if="props.item.telephone === true"><v-icon color="grey">phone</v-icon>&nbsp;Telephone</p>
                           <p v-if="props.item.fullTimeService === true"><v-icon color="grey">room_service</v-icon>&nbsp;Full Time Service</p>
                        </v-flex>
                     </v-layout> -->
                     <div class="aminity">
                      <p class="aminities" style="font-size:12px" v-if="props.item.parkingPlace === true"><v-icon size="20px" color="grey">local_taxi</v-icon>&nbsp;Parking Place</p>
                      <p class="aminities" style="font-size:12px" v-if="props.item.telephone === true"><v-icon size="20px" color="grey">phone</v-icon>&nbsp;Telephone</p>
                      <p class="aminities" style="font-size:12px" v-if="props.item.fullTimeService === true"><v-icon size="20px" color="grey">room_service</v-icon>&nbsp;Room Service</p>
                     </div>
                     <div class="aminity">
                      <p class="aminities white--text" style="font-size:12px" v-if="props.item.parkingPlace === false"><v-icon size="20px" color="white">local_taxi</v-icon>&nbsp;Parking Place</p>
                      <p class="aminities white--text" style="font-size:12px" v-if="props.item.telephone === false"><v-icon size="20px" color="white">phone</v-icon>&nbsp;Telephone</p>
                      <p class="aminities white--text" style="font-size:12px" v-if="props.item.fullTimeService === false"><v-icon size="20px" color="white">room_service</v-icon>&nbsp;Room Service</p>
                     </div>


                     <!-- <v-btn depressed class="white--text" color="#ff336d" @click="view(props.item)">
                       <v-icon color="white">visibility</v-icon>&nbsp;View Details</v-btn>
                       <v-btn depressed color="primary" @click="view(props.item)">
                      <v-icon color="white">book</v-icon>&nbsp;Book now</v-btn> -->
                  </v-flex>
                  <v-flex xs12 md2 sm12 style="padding-right:5px;padding-left:5px">
                    <v-container class="form-container rate">
                       <p v-if="props.item.breakFast === true" style="font-size:10px; text-align:center; margin-bottom: 5px;" class="white--text">INCLUDE IN THIS PRICE</p>
                       <p v-if="props.item.breakFast === true" class="lime--text" style="font-size:11px; text-align:center; margin-bottom: 15px;"><v-icon color="#c6ff00" size="14px">done</v-icon>&nbsp;Free Breakfast</p>

                       <!-- ========================================================================== -->
                       <p v-if="props.item.breakFast === false" style="font-size:10px; text-align:center; margin-bottom: 5px;" class="white--text lineThrough">INCLUDE IN THIS PRICE</p>
                       <p v-if="props.item.breakFast === false" class="lime--text lineThrough" style="font-size:11px; text-align:center; margin-bottom: 15px;">Free Breakfast</p>
                       <!-- ========================================================================== -->

                       <p style="text-align:center; margin-bottom:0px;">
                         <span class="yellowText font12">
                           <span>Save </span>
                           <span class="latoBold">INR {{props.item.save}} <br/><v-btn class="ma-2 " style="pointer-events: none;border-radius:50%" fab color="yellow">
                            <h5 style="margin-top:5px">{{props.item.discount}}%</h5>
                           </v-btn></span>
                         </span>
                       </p>
                       <p class="lineThrough" style="text-align:center; color:#e0e0e0; font-size:15px; margin-bottom:0px;">INR {{props.item.regularPrice}}</p>
                       <p class="white--text" style="text-align:center; font-size:25px; margin-top:0px;margin-bottom:0px;">INR {{props.item.actualPrice}}</p>
                       <p style="text-align:center; margin-top:0px;margin-bottom:0px; color:#e0e0e0">Per night</p>
                       <p style="text-align:center; color:#e0e0e0">All Tax Included</p>
                    </v-container>
                  </v-flex>
                  <v-flex xs12 md2 sm12 style="text-align:center">
                     <v-btn depressed class="white--text" color="#ff336d" @click="view(props.item)">
                       <v-icon color="white">visibility</v-icon>&nbsp;View Details</v-btn>
                       <v-btn depressed color="primary" @click="view(props.item)">
                      <v-icon color="white">book</v-icon>&nbsp;Book now</v-btn>
                  </v-flex>
              </v-layout>
              </v-container>
              <br>
          </td>
                  </template>
      </v-data-table>
    </v-flex>
  </v-layout>
  
</div>
  </v-app>
</template>

<script>
import config from "./../../config.json";
import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';

export default {
  components: {
    VueEasyLightbox,
    GoTop
  },
  data() {
    return {
      srch: false,
      min: 0,
        max: 30000,
        slider: 40,
        range: [0, 30000],

      imgs: '',  // Img Url , string or Array
      visible: false,
      index: 0,  // default\
      rating: 0,

      dialog: false,
      dialog1: false,
      checkInModel: false,
      checkOutModel: false,
      DateModel: false,
      entries: [],
      hotels: [],
      cities: null,
      premiumHotels: null,
      recommendedCityList: null,

      selectedCity: sessionStorage.city,

      search: "",
      valid: true,
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required."
      },
      
      selectedRoom: sessionStorage.room,
      rooms: ["1", "2", "3", "4", "5"],
      
      selectedAdult: sessionStorage.adult,
      adults: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],

      selectedChildren: sessionStorage.baccha,
      children: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],

      passwordShow: false,
      isLoading: false,
      form: {
        UserName: null,
        password: null
      },

      selectedHotel: null,

      form1: {
        //checkIn: null,
       checkIn: sessionStorage.hey,
       checkOut: sessionStorage.hello,
       date: new Date().toISOString().substr(0, 10)
      },

      

       src: {
        src1: null,
        src2: null,
        src3: null,
        src4: null,
        src5: null,
        src6: null,
        src7: null,
        src8: null,
        src9: null,
        src10: null
      },

      days: null

    };
  },
  
   mounted() {

     //======================================= NEXT DATE =================================================


      var today = new Date();
      var tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000)).toISOString().substr(0, 10);
      //this.form1.checkOut = tomorrow;
  

      this.getData();
      this.getData1();

   },

 methods: {
     getData() {
    this.axios
      .get(config.API + "MainPage", {
      })
      .then(res => {
        this.cities = res.data.cities;
        this.premiumHotels = res.data.premiumHotelList;
        this.recommendedCityList = res.data.recommendedCityList;
      })
   },
   
   getData1() {
      var retrievedData = sessionStorage.getItem("hotels");
      this.hotels = JSON.parse(retrievedData);
      this.getData1();
   },

   showMultiple(item) {
     this.axios
        .get(config.API + "HotelsImageShow/" + item.id, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.src.src1 = res.data.src1;
          this.src.src2 = res.data.src2;
          this.src.src3 = res.data.src3;
          this.src.src4 = res.data.src4;
          this.src.src5 = res.data.src5;
          this.src.src6 = res.data.src6;
          this.src.src7 = res.data.src7;
          this.src.src8 = res.data.src8;
          this.src.src9 = res.data.src9;
          this.src.src10 = res.data.src10;
          this.imgs = [this.src.src1, this.src.src2, res.data.src3, res.data.src4, res.data.src5, res.data.src6, res.data.src7, res.data.src8, res.data.src9, res.data.src10]
          this.index = 1  // index of imgList
          this.show()
        })
      
    },
    show() {
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },

   login() {
     this.$router.push(`/login`);
   },

   view(item) {
     this.$router.push(`viewHotelDetails/${item.id}`);
   },

   detail(premium) {
     this.$router.push(`_viewHotelDetails/${premium.hotelId}`);
   },

   main() {
     this.$router.push(`/aimro`);
     this.hotels = null;
     this.selectedCity = null;
     this.selectedRoom = null;
     this.selectedAdult = null;
     this.selectedChildren = 0;
   },



   onSubmit() {
        this.isLoading = true;
      let UserName = this.form.UserName;
      let Password = this.form.Password;
      this.$store
        .dispatch("login", { UserName, Password })
        .then(() => {
          setTimeout(() => {
            this.$toaster.success("Login successfull");
            this.isLoading = false;
            this.$router.push("/_");
          }, 1000);
        })
        .catch(err => {
          this.$toaster.error("Wrong usernam or password !!");
          this.isLoading = false;
        });
    },

    searchHotel() {
      var _date1 = new Date(this.form1.checkIn);
      var _date2 = new Date(this.form1.checkOut);

      var different_in_time = _date2.getTime() - _date1.getTime();

      var different_in_days = different_in_time / (1000 * 3600 * 24);

      this.days = different_in_days;

      if (this.days > 0) {
        if (this.$refs.form1.validate()) {
          this.srch = true;
        this.axios
          .post(
            config.API + `HotelList`,
            {
              city: this.selectedCity
            }
          )
          .then(res => {
            //console.log(res.data);
            this.hotels = res.data;

            sessionStorage.setItem("hotels", JSON.stringify(this.hotels));
            //const hey = this.form1.ckeckIn;
            sessionStorage.setItem("city", this.selectedCity);
            sessionStorage.setItem("room", this.selectedRoom);
            sessionStorage.setItem("adult", this.selectedAdult);
            sessionStorage.setItem("baccha", this.selectedChildren);
            sessionStorage.setItem("hey", this.form1.checkIn);
            sessionStorage.setItem("hello", this.form1.checkOut);
            this.srch = false;
          })
          .catch(err => {
            this.srch = false;
          });
      }
      } else {
        this.$toaster.error("Check-Out Date should be greater than Check-In Date");
      }
      
    }
 }
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
</style>

<style scoped>
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.ss {
  border-radius: 5%;
  height: 60px !important;
}
.ss1 {
  border-radius: 5%;
  height: 58px !important;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.near {
  top: -70px;
  position: relative;
}
.near1 {
  top: -70px;
  bottom: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 70px;
}
.pdng {
  padding-bottom: -25px !important;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.hotel_name1 {
  font-family: 'Anton', sans-serif;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: #fff !important;
  border-bottom: none !important;
}
td.hvr:hover {
  background-color: #fff !important;
  background: #fff !important;
  border-bottom: none !important;
}
.rate {
  height: 280px;
  border-radius: 4%;
  background-image: linear-gradient(#7b1fa2, #e91e63);
 /* background-color: #eeeeee; */
}
.yellowText {
    color: yellow;
}
.font12 {
    font-size: 12px;
    line-height: 12px;
}
.latoBold {
    font-weight: 700;
}
.sprite.discountIcon {
    width: 38px;
    height: 17px;
    background-position: -206px -73px;
}
.appendLeft5 {
    margin-left: 5px;
}
.sprite {
    background: url(//imgak.mmtcdn.com/pwa_v3/pwa_hotel_assets/web/hotelSprite-v4.png) no-repeat;
    display: inline-block;
    background-size: 400px 400px;
    font-size: 0px;
    flex-shrink: 0;
}
.font11 {
    font-size: 11px;
    line-height: 11px;
}
.discountText {
    display: inline-block;
    position: absolute;
    left: 12px;
    top: 2px;
}
.lineThrough {
  text-decoration: line-through;
}
.filtr {
  background-image: linear-gradient(#e91e63, #7b1fa2);
}
.aminity {
  width: 100%;
}
.aminities {
  width: 30%;
  float: left;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
tr {
  border-bottom: none !important;
}
.form-container {
  margin: 0px !important;
}
@media screen and (max-width: 768px) {
  .heading_1 {
    font-size: 14px;
  }
  .rspnsv {
    margin-bottom: 30px;
    height: auto;
  }
  ._hello {
    height: auto !important;
  }
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
.abc {
  overflow: hidden !important;
}

</style>
